// Edit.js
import React, { useEffect, useState } from "react";
import { useEditLogic } from "./EditLogic";
import "./Edit.css";
import { MdCancel, MdClose } from "react-icons/md";
import { IoIosArrowUp, IoIosArrowDown, IoIosArrowBack } from "react-icons/io";
import { FaPlus, FaEdit, FaSave } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import ItemsAndPresetObjectsModal from './ItemAndPresetObjectsModal';
import ViewCk_Dictionary from "./ViewCk_Dictionary";
import { IoIosEyeOff } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin3Fill, RiDeleteBin4Fill } from "react-icons/ri";

export default function Edit() {
    const {
        openAddModal,
        setOpenAddModal,
        editObject,
        toggleModal,
        category,
        displayId,
        displayName,
        setDisplayId,
        setDisplayName,
        handleUpdateDictionary,
        isEditMode,
        isItemListOpen,
        isPresetListOpen,
        toggleItemList,
        togglePresetList,
        itemLists,
        presetList,
        handleAddItemList,
        handleAddPresetList,
        handleEditItemList,
        handleEditPresetList,
        handleSaveDictionary,
        getJsonFromModal,
        ck_dictionary_id,
        hasSubGroup,
        setHasSubGroup, handleAddSubGroup,
        setSubGroups,
        subGroups,
        handleEditSubGroup,
        handleEditItemInSubGroup,
        handleAddItem,
        isEditModeOn, handleBack, setDisplayView, displayView,
        isShowModel, setIsShowModel, dictionaryHeader, setDictionaryHeader, location, showError, setShowError,
        isHeaderDisabled,handleDeleteItem,handleDeleteItemInSub,handleUpdateBasicInfo,isSubGroupDisabled,handleDeletePreset
    } = useEditLogic();

    const navigate = useNavigate();


    const toggleSubGroupItems = (subIndex) => {
        setSubGroups(prev =>
            prev.map((sub, index) =>
                index === subIndex
                    ? { ...sub, isOpen: !sub.isOpen }
                    : sub
            )
        );
    };



    useEffect(() => {
        if (location.state?.openModal) {
            setIsShowModel(true);
        }
    }, [location.state]);

    const handleNavigateBack = () => {
        navigate(-1);
        setShowError(false);

    }





    return (
        <div className="main-content">



                <div>
                    <div className="p-2 custom-bg-white rounded d-flex justify-content-between align-items-center">
                        <button className="back-btn" onClick={handleBack}>
                            <IoIosArrowBack /> Back
                        </button>
                    </div>
                    <div className="custom-bg-white edit-main-content-2 mt-4 p-3">
                        <div className="inner-content">
                            {/* Header row: Dictionary ID + Display Name */}
                            <div className="row mb-4 mt-2">
                                <div className="display-name-row">
                                    <div className="display-label-input">
                                        <label className="display-label">Display Name</label>

                                        <input
                                            type="text"
                                            value={dictionaryHeader.displayName}
                                            onChange={(e) =>
                                                setDictionaryHeader({
                                                    ...dictionaryHeader,
                                                    displayName: e.target.value
                                                })
                                            }
                                            maxLength={100}
                                            className="form-control display-input"
                                            placeholder="Enter display name"
                                        />
                                    </div>
                                    <div className="subgroup-checkbox">
                                        <input
                                            type="checkbox"
                                            id="hasSubGroup"
                                            checked={dictionaryHeader.hasSubGroup}
                                             disabled={isSubGroupDisabled}
                                            onChange={(e) =>
                                                setDictionaryHeader({
                                                    ...dictionaryHeader,
                                                    hasSubGroup: e.target.checked
                                                })
                                            }
                                            className="checkbox-input"
                                        />
                                        <label  className="checkbox-label">
                                            Is having sub group
                                        </label>
                                    </div>

                                    <div className="view-selector">
                                        <div className="radio-option">
                                            <input
                                                type="radio"
                                                name="viewType"
                                                id="gridView"
                                                value="grid"
                                                checked={dictionaryHeader.displayView === "grid"}
                                                onChange={(e) =>
                                                    setDictionaryHeader({
                                                        ...dictionaryHeader,
                                                        displayView: e.target.value
                                                    })
                                                }
                                            />
                                            <label htmlFor="gridView">Grid</label>
                                        </div>

                                        <div className="radio-option">
                                            <input
                                                type="radio"
                                                name="viewType"
                                                id="listView"
                                                value="list"
                                                //disabled={isHeaderDisabled}
                                                checked={dictionaryHeader.displayView === "list"}
                                                onChange={(e) =>
                                                    setDictionaryHeader({
                                                        ...dictionaryHeader,
                                                        displayView: e.target.value
                                                    })
                                                }
                                            />
                                            <label htmlFor="listView">List</label>
                                        </div>
                                    </div>

                                    <div className="button-container">
                                        <button onClick={handleUpdateBasicInfo}>Update basic info</button>
                                    </div>
                                    </div>

                            </div>


                            {/* ITEM LIST */}

                            {!dictionaryHeader.hasSubGroup ? (
                                <div className="edit-accordion-item">
                                    <div className="edit-accordion-header" onClick={toggleItemList}>
                                        <div>
                                            <span>Item List</span>
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                        >
                                            <div className="d-flex justify-content-end ">
                                                <button
                                                    type="button"
                                                    className="edit-add-btn d-flex align-items-center"
                                                    onClick={handleAddItemList}
                                                >
                                                    Add Items List
                                                </button>
                                            </div>
                                            <span style={{ marginLeft: '20px' }} onClick={toggleItemList}>
                                                {isItemListOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                            </span>
                                        </div>

                                    </div>

                                    {isItemListOpen && (
                                        <div className="edit-accordion-content">


                                            <div className="edit-table-content">
                                                <table className="table table-bordered">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th>Display Text</th>
                                                            <th>Items Count</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemLists.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No Records Found
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            itemLists.map((row, index) => (
                                                                <tr key={index}>
                                                                    <td className="subitem-text">{row.displayText}</td>
                                                                    <td>{row.itemsCount}</td>
                                                                    <td>
                                                                        <span className="edit-action-icon">
                                                                            <FaEdit
                                                                                onClick={() => handleEditItemList(row, index)}
                                                                            />
                                                                            <RiDeleteBin4Fill color="red" onClick={() => handleDeleteItem(row.displayText)} />

                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) :
                                (
                                    <div className="edit-accordion-item">
                                        <div className="edit-accordion-header" onClick={toggleItemList} >
                                            <div>
                                                <span>{dictionaryHeader.hasSubGroup ? "Sub Group" : "Item List"}</span>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}

                                            >
                                                <div className="d-flex justify-content-end " >
                                                    {dictionaryHeader.hasSubGroup && (
                                                        <button
                                                            type="button"
                                                            className="edit-add-btn"
                                                            onClick={() => handleAddSubGroup()}
                                                        >
                                                            Add Sub Group
                                                        </button>
                                                    )}
                                                </div>
                                                <span style={{ marginLeft: '20px' }} onClick={toggleItemList}>
                                                    {isItemListOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </span>
                                            </div>

                                        </div>

                                        {isItemListOpen && (
                                            <div className="edit-accordion-content">
                                                {dictionaryHeader.hasSubGroup && (
                                                    <div className="edit-table-content">
                                                        <table className="table table-bordered">
                                                            <thead className="thead-dark">
                                                                <tr>
                                                                    <th>Display Text</th>
                                                                    <th>Display</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {subGroups.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="3" className="text-center">
                                                                            No SubGroups Added
                                                                        </td>
                                                                    </tr>
                                                                ) : (

                                                                    subGroups.map((sub, subIndex) => (
                                                                        <React.Fragment key={subIndex}>

                                                                            {/* SubGroup Row */}
                                                                            <tr className="subgroup-row">
                                                                                <td className="subitem-text">{sub.displayText}</td>
                                                                                <td>{sub.display}</td>
                                                                                <td className="edit-action-icon">
                                                                                   
                                                                                    <FaEdit onClick={() => handleEditSubGroup(sub, subIndex)} size={16}/>
                                                                                    
                                                                                    {sub.items && sub.items.length > 0 && (
                                                                                        <span
                                                                                            className="eye-toggle"
                                                                                            onClick={() => toggleSubGroupItems(subIndex)}
                                                                                            title={sub.isOpen ? "Hide Items" : "Show Items"}
                                                                                        >
                                                                                            {sub.isOpen ? <IoIosEyeOff size={20} /> : <FaEye size={16} />}
                                                                                        </span>
                                                                                    )}
                                                                                    
                                                                                    <button
                                                                                        type="button"
                                                                                        className="edit-add-btn"
                                                                                        onClick={() => handleAddItem(subIndex)}
                                                                                    >
                                                                                        Add Items List
                                                                                    </button>
                                                                                </td>
                                                                            </tr>

                                                                            {/* SUBGROUP ITEMS TABLE */}
                                                                            {sub.isOpen && sub.items?.length > 0 && (
                                                                                <tr >
                                                                                    <td colSpan="3">
                                                                                        <div className="subitem-wrapper-row">
                                                                                            <table className="subitem-table">
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th>Display Text</th>
                                                                                                        <th>Items Count</th>
                                                                                                        <th>Actions</th>
                                                                                                    </tr>
                                                                                                </thead>

                                                                                                <tbody>
                                                                                                    {sub.items.map((item, itemIndex) => (
                                                                                                        <tr key={itemIndex}>
                                                                                                            <td className="subitem-text">{item.displayText}</td>
                                                                                                            <td>{item.itemsCount || 0}</td>
                                                                                                            <td className="edit-action-icon">
                                                                                                                <FaEdit onClick={() => handleEditItemInSubGroup(subIndex, itemIndex)} />

                                                                                                                <RiDeleteBin4Fill color="red" onClick={() => handleDeleteItemInSub(sub.displayText, item.displayText)}/>
    
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    ))}
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )}

                                                                        </React.Fragment>
                                                                    ))
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}


                                            </div>
                                        )}
                                    </div>
                                )
                            }


                            {/* PRESET LIST */}
                            <div className="edit-accordion-item">
                                <div className="edit-accordion-header" onClick={togglePresetList} >
                                    <div>
                                        <span>Preset List</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}

                                    >
                                        <div className="d-flex justify-content-end">
                                        {!presetList && (
                                            <button
                                                type="button"
                                                className="edit-add-btn d-flex align-items-end"
                                                onClick={handleAddPresetList}
                                            >
                                                Add Preset List
                                            </button>
                                        )}
                                        </div>
                                        <span style={{ marginLeft: '20px' }} onClick={togglePresetList}>
                                            {isPresetListOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                        </span>
                                    </div>

                                </div>

                                {isPresetListOpen && (
                                    <div className="edit-accordion-content">

                                        <div className="edit-table-content">
                                            <table className="table table-bordered">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Display Text</th>
                                                        <th>Preset Count</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                            <tbody>
                                                {!presetList ? (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">
                                                            No Records Found
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td className="subitem-text">{presetList.displayText}</td>
                                                        <td>{presetList.presetCount}</td>
                                                        <td>
                                                            <span className="edit-action-icon">
                                                                <FaEdit onClick={() => handleEditPresetList(presetList)} />
                                                                <RiDeleteBin4Fill
                                                                    color="red"
                                                                    onClick={() => handleDeletePreset(presetList.displayText)}
                                                                />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* <div className="save-btn-wrapper">
                                <button
                                    className="edit-final-save-btn"
                                    onClick={handleGenerateDictionary}
                                >
                                    <FaSave className="edit-save-icon" />
                                    Generate CK_Dictionary
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>


            {isShowModel && (
                <div className="dict-overlay">
                    <div className="dict-modal">

                        {/* Header */}
                        <div className="dict-header">
                            <span className="dict-title">Add Dictionary</span>
                            <MdCancel
                                size={22}
                                className="dict-close"
                                onClick={handleNavigateBack}
                            />
                        </div>

                        {/* Body */}
                        <div className="dict-content">
                            <form className="dict-form" onSubmit={handleSaveDictionary}>

                                {/* Display Name */}
                                <div className="dict-field">
                                    <label className="dict-label">Display Name</label>
                                    <input
                                        type="text"
                                        value={displayName}
                                        onChange={(e) => {
                                            setDisplayName(e.target.value)
                                            setShowError(false)
                                        }}
                                        maxLength={100}
                                        className="dict-input"
                                        placeholder="Enter display name"
                                    />
                                    {showError && (
                                        <div className="popup-error">
                                            Please provide a display name
                                        </div>
                                    )}
                                </div>

                                {/* Subgroup */}
                                <div className="dict-checkbox-wrapper">
                                    <input
                                        type="checkbox"
                                        id="hasSubGroup"
                                        checked={hasSubGroup}
                                        onChange={(e) => setHasSubGroup(e.target.checked)}
                                        className="dict-checkbox"
                                    />
                                    <label  className="dict-checkbox-label">
                                        Is having sub group
                                    </label>
                                </div>

                                {/* View Type */}
                                <div className="dict-radio-wrapper">
                                    <span className="dict-label">Display View</span>

                                    <div className="dict-radio-options">
                                        <label className="dict-radio-item">
                                            <input
                                                type="radio"
                                                name="viewType"
                                                value="grid"
                                                checked={displayView === "grid"}
                                                onChange={(e) => setDisplayView(e.target.value)}
                                            />
                                            Grid
                                        </label>

                                        <label className="dict-radio-item">
                                            <input
                                                type="radio"
                                                name="viewType"
                                                value="list"
                                                checked={displayView === "list"}
                                                onChange={(e) => setDisplayView(e.target.value)}
                                            />
                                            List
                                        </label>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="dict-actions">
                                    <button
                                        type="button"
                                        className="dict-btn-cancel"
                                        onClick={handleNavigateBack}>
                                        Cancel
                                    </button>

                                    <button type="submit" className="dict-btn-save">
                                        Save
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            )}


            {openAddModal && <ItemsAndPresetObjectsModal onClose={toggleModal} type={category} existingObject={editObject}
                isEditModeOn={isEditModeOn} getJsonFromModal={getJsonFromModal} />}
        </div>
    );
}
